import clsx from "clsx";
import { Globe } from "lucide-react";

import type { HolidayRegion } from "../../types.ts";
import { REGION_LABELS } from "../../constants.ts";

import styles from "./region-badge.module.css";

export interface RegionBadgeProps {
  region: HolidayRegion;
  className?: string;
}

const FLAG_BY_REGION: Record<HolidayRegion, string | null> = {
  INDIA: "/assets/indian-flag.svg",
  US: "/assets/us-flag.svg",
  UK: "/assets/uk-flag.svg",
  SQE: null,
  GLOBAL: null,
};

export function RegionBadge({ region, className }: RegionBadgeProps) {
  const label = REGION_LABELS[region];
  const flagSrc = FLAG_BY_REGION[region];
  const variantClass =
    region === "INDIA"
      ? styles.india
      : region === "US"
        ? styles.us
        : region === "UK"
          ? styles.uk
          : region === "SQE"
            ? styles.sqe
            : styles.global;

  return (
    <span className={clsx(styles.root, variantClass, className)}>
      {flagSrc ? (
        <img
          src={flagSrc}
          alt=""
          className={styles.flag}
          width={18}
          height={12}
        />
      ) : region === "GLOBAL" ? (
        <Globe size={14} strokeWidth={2} className={styles.globe} aria-hidden />
      ) : null}
      <span className={styles.label}>{label}</span>
    </span>
  );
}
